module.exports = __webpack_public_path__ + "img/124.6eeb8974.jpg";